<template>
  <CarnetsList/>
</template>
<script>
import CarnetsList from '@/components/modules/admin/carnets/list_no_actions'
export default {
  name: 'adminCarnets',
  components: {
    CarnetsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/list_no_actions.vue